import useRoles from '@wiggot/auth/hooks/useRoles'
import { EnumRole } from '../../../interfaces/src'
import { RuleNameType } from '../types'
import { useValidateRules } from './useValidateRules'
import { HomeActionTypes, useHomeStore } from '../store'
import { ModalType } from '../components'
import { legacyApiAuth } from '@wiggot/apis'

export interface IsEnableActionProps {
  rule: RuleNameType | undefined
  rol: EnumRole | undefined
  cb: any | undefined
  paramsCb: any | undefined
  dispatchType?: any | undefined
  modalType?: any | undefined
  isShowModal?: boolean | undefined
}

const useValidateEnabledAction = () => {
  const { dispatch } = useHomeStore()
  const { rulesValidations } = useValidateRules()
  const { roles } = useRoles()

  const validateRole = (rolNecessary: EnumRole) => {
    let isValid = false
    if (rolNecessary === EnumRole.STARTER) {
      isValid = Boolean(roles?.STARTER) || Boolean(roles?.ADVANCED)
    }
    isValid = Boolean(roles?.ADVANCED)
    return isValid
  }

  const isPublishLimitStarter = async (cb: any, paramsCb: any | undefined) => {
    try {
      const response: { properties: number } = await legacyApiAuth.get(
        '/v2/properties/metrics/published_in_portals'
      )
      if (response.properties) {
        if (roles?.STARTER && response.properties > 9) {
          dispatch({
            type: HomeActionTypes.TOGGLE_UPGRADE_MODAL,
            payload: {
              type: ModalType.ADVANCE,
              isShow: true
            }
          })
        } else {
          cb(paramsCb)
        }
      } else {
        cb(paramsCb)
      }
    } catch (error) {
      console.log(error)
      cb(paramsCb)
    }
  }

  const isEnableAction = ({
    rule,
    rol,
    cb,
    paramsCb,
    dispatchType = HomeActionTypes.TOGGLE_UPGRADE_MODAL,
    modalType = null,
    isShowModal = true
  }: IsEnableActionProps) => {
    let isContinue = true
    if (rule && rol) {
      isContinue =
        Number(rulesValidations[rule]?.value) === 1 && validateRole(rol)
    } else if (rule) {
      isContinue = Number(rulesValidations[rule]?.value) === 1
    }
    if (!isContinue && rol) {
      const defaultModalType =
        roles?.[rol] === EnumRole.STARTER
          ? ModalType.STARTER
          : ModalType.ADVANCE
      dispatch({
        type: dispatchType,
        payload: {
          type: modalType ?? defaultModalType,
          isShow: isShowModal
        }
      })
    }
    if (cb && isContinue) {
      cb(paramsCb)
    }
  }

  const validateIfExistRule = (rule: RuleNameType | undefined) => {
    if (rule) {
      return Number(rulesValidations[rule]?.value) === 1
    }
    return false
  }

  return {
    isEnableAction,
    isPublishLimitStarter,
    validateIfExistRule
  }
}

export default useValidateEnabledAction
